var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0771 13.6906L9.1198 0.193129C8.96776 0.0838423 8.78776 0.018102 8.59985 0.00323433C8.41194 -0.0116334 8.22351 0.0249545 8.05557 0.108923C7.88762 0.192892 7.74675 0.320941 7.64866 0.478801C7.55057 0.63666 7.49911 0.818128 7.50001 1.00298V27.998C7.50001 28.8204 8.44756 29.285 9.1198 28.8079L28.0771 15.3103C28.208 15.2179 28.3146 15.0962 28.3881 14.9554C28.4617 14.8146 28.5 14.6587 28.5 14.5005C28.5 14.3423 28.4617 14.1864 28.3881 14.0456C28.3146 13.9048 28.208 13.7831 28.0771 13.6906Z",
    fill: "#FDF6E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.49bb643f199438903516d097e8cb7ec6.svg";
export { ForwardRef as ReactComponent };